"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _likelihood = _interopRequireDefault(require("../options/likelihood.json"));

var _rate = _interopRequireDefault(require("../options/rate.json"));

var _able = _interopRequireDefault(require("../options/able.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.WRKBTY;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: ""
};
var workabilityQuestions = [{
  prompt: "Assume that your work ability at its best has a value of 10 points. How many points would you give your current work ability? (0 means that you cannot currently work at all)",
  options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
  type: "slider"
}, {
  prompt: "How do you rate your current work ability with respect to the physical demands of your work?",
  options: _rate["default"],
  type: "dot"
}, {
  prompt: "How do you rate your current work ability with respect to the mental demands of your work?",
  options: _rate["default"],
  type: "dot"
}, {
  prompt: "Do you believe that – from the standpoint of your health – you will be able to do your current job two years from now?",
  options: _able["default"],
  type: "multi"
}];
var questions = (0, _utils.wrapBattery)(workabilityQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    WRK: score,
    WRK_1: answers[0],
    WRK_2: answers[1],
    WRK_3: answers[2],
    WRK_4: answers[3]
  };
}